import type { FaireAdCampaignEntity } from "../../entity_types/adCampaign";

export const campIdgNew: FaireAdCampaignEntity = {
  token: "camp_idg_new",
  type: "adCampaign",
  advertiserProfileToken: "adv_island_dogs",
  segment: "NEW_MARKETPLACE",
  status: "RUNNING",
  monthlyBudgetDollars: 2000,
  startedRunningAt: "2023-10-31",
  segmentMetrics: {
    numCustomersAcquired: 210,
    salesDollars: 92864,
    totalAdsSpendDollars: 23425,
    cpaDollars: 111.55,
    bestEstimateSalesDollars: 78403,
    bestEstimateRoas: 3.35,
  },
  performancePeriodTokens: [],
  meta: {
    source: "snowflake",
    importedAt: "2026-09-27T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
